//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-label',
  props: {
    isDark: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
    onKeypress() {
      this.$emit('keypress')
    },
  },
}
